import { TextLink, TextLinkStyle, useTranslation } from '@nextgen-web-framework/all';
import { isValidPhoneNumber } from 'libphonenumber-js/max';
import { isEmail } from '../../../utils/helper';
import { OtpVerificationProps } from '../types/propTypes';
import useTransformPhoneNumber from '../../../utils/customHooks/useTransformPhoneNumber';
import styles from './OtpSentFeedback.module.scss';
const OtpSentFeedback = ({
  username,
  showChangeCTA,
  onChangeCTA,
  showLabelForForgotPassword,
}: Partial<OtpVerificationProps>) => {
  const t = useTranslation();
  const { transformPhoneNumber } = useTransformPhoneNumber();
  const isUsernameEmail = isEmail(`${username}`);
  const userType = isUsernameEmail
    ? t('identity.UsernameSentNotification.emailLabel')
    : t('identity.UsernameSentNotification.mobileLabel');
  const changeText = isUsernameEmail ? t('identity.VerifyOtp.emailLabel') : t('identity.VerifyOtp.mobileLabel');
  const textLinkProps = {
    text: changeText,
    textLinkStyle: TextLinkStyle['UNDERLINE'],
    role: 'presentation',
    onClick: onChangeCTA,
  };
  let consumer: string | undefined;

  if (isUsernameEmail) {
    consumer = username;
  } else if (isValidPhoneNumber(username as string)) {
    consumer = transformPhoneNumber(`${username}`);
  } else {
    consumer = username;
  }

  const bodyLabel = showLabelForForgotPassword
    ? `${t('identity.VerifyOtp.bodyLabelForForgotPassword1', {
        consumer: `${consumer}`,
      })} ${t('identity.VerifyOtp.bodyLabelForForgotPassword2', {
        userType: `${userType}`,
      })}`
    : `${t('identity.VerifyOtp.bodyLabel')} ${userType}`;
  return (
    <div className={styles['otp-sent-feedback']}>
      <span className={styles['label1']}>{bodyLabel}</span>
      <div className={showLabelForForgotPassword ? styles['label3'] : styles['label2']}>
        <div>{!showLabelForForgotPassword && `(${consumer})`}</div>
        {showChangeCTA && (
          <div className={styles['cta-link']}>
            <TextLink data-testid="change-username-test-id" {...textLinkProps} />
          </div>
        )}
      </div>
    </div>
  );
};

export default OtpSentFeedback;
